import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Typography } from '@mui/material'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import BlockIcon from '@mui/icons-material/Block';
import UndoIcon from '@mui/icons-material/Undo';
import { formatearFecha } from '../../utils/utils';

export const DialogRechazarModificacion = ({ open2, setOpen2, fichaje, tipo, actualizarFichajePendiente, index }) => {

    if (!fichaje) return null;

    const esCorreccion = tipo === "correccion";
    const esAnulacion = tipo === "anulacion";

    // ID seguro para abrir dialog y enviar update
    const idSeguro =
        fichaje.fichaje_modificado?.id ??
        fichaje.fichaje_original?.id ??
        fichaje.id_fichaje;
    const handleRechazar = () => {
        if (!idSeguro) return;

        if (esCorreccion) {
            actualizarFichajePendiente(idSeguro, 2, "correccion");
        } else {
            actualizarFichajePendiente(idSeguro, 2, "anulacion");
        }
    };

    return (
        <Dialog
            open={open2 === index}
            onClose={() => setOpen2(null)}
            fullWidth
            maxWidth='md'
        >
            <DialogTitle>
                <Grid container xs={12}>
                    <Typography variant='h5'>
                        <BlockIcon sx={{ mb: -1, fontSize: 35 }} color='error' />

                        {esCorreccion && (
                            <> Rechazar modificación de fichaje Nº{idSeguro ?? "—"}</>
                        )}

                        {esAnulacion && (
                            <> Rechazar anulación de fichaje Nº{idSeguro ?? "—"}</>
                        )}
                    </Typography>

                    <Divider sx={{ width: '100%', mt: 1 }} />
                </Grid>
            </DialogTitle>

            <DialogContent>
                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems="start"
                    xs={12} gap={1}
                >
                    <Typography variant='body1'>
                        {esCorreccion && (
                            <>
                                ¿Estás seguro de que deseas <strong>rechazar</strong> la modificación del fichaje Nº{idSeguro}?<br />
                                El fichaje corregido será descartado.
                            </>
                        )}

                        {esAnulacion && (
                            <>
                                ¿Estás seguro de que deseas <strong>rechazar</strong> la anulación del fichaje Nº{idSeguro}?<br />
                                El fichaje volverá a estar activo.
                            </>
                        )}
                    </Typography>

                    {/* SOLO PARA CORRECCIÓN: mostrar comparativa */}
                    {esCorreccion && (
                        <Grid container direction="column" gap={2} xs={12}>

                            {/* ORIGINAL (si existe) */}
                            {fichaje.fichaje_original ? (
                                <Grid container xs={12} sx={{
                                    backgroundColor: 'lightgray',
                                    p: 0.5,
                                    borderLeft: "5px solid gray",
                                    borderRadius: 2
                                }}>
                                    <Typography variant='subtitle1'>Fichaje original</Typography>
                                    <Divider sx={{ width: '100%', my: 0.5 }} />

                                    <Grid container justifyContent="space-between">
                                        <Typography>
                                            Inicio: {formatearFecha(fichaje.fichaje_original?.hora_inicio) ?? "—"}
                                        </Typography>
                                        <Typography>
                                            Fin: {formatearFecha(fichaje.fichaje_original?.hora_fin) ?? "—"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid container xs={12} sx={{
                                    backgroundColor: '#ffe6cc',
                                    p: 0.5,
                                    borderLeft: "5px solid #ff9900",
                                    borderRadius: 2
                                }}>
                                    <Typography variant='subtitle1'>No existe fichaje original</Typography>
                                    <Divider sx={{ width: '100%', my: 0.5 }} />
                                    <Typography variant='body2'>
                                        Este fichaje fue creado manualmente.
                                    </Typography>
                                </Grid>
                            )}

                            {/* Flecha, solo si existía original */}
                            {fichaje.fichaje_original && (
                                <Grid container justifyContent="center">
                                    <KeyboardDoubleArrowRightIcon color='action' sx={{ fontSize: 40, transform: 'rotate(90deg)' }} />
                                </Grid>
                            )}

                            {/* MODIFICADO (siempre debe existir) */}
                            <Grid container xs={12} sx={{
                                backgroundColor: 'lightcoral',
                                p: 0.5,
                                borderLeft: "5px solid red",
                                borderRadius: 2
                            }}>
                                <Typography variant='subtitle1'>Fichaje modificado</Typography>
                                <Divider sx={{ width: '100%', my: 0.5 }} />

                                <Grid container justifyContent="space-between">
                                    <Typography>
                                        Inicio: {fichaje.fichaje_modificado?.hora_inicio ?? "—"}
                                    </Typography>
                                    <Typography>
                                        Fin: {fichaje.fichaje_modificado?.hora_fin ?? "—"}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                    )}

                </Grid>
            </DialogContent>

            <DialogActions>
                <Grid container justifyContent={{ xs: 'space-between', md: 'end' }} xs={12} gap={2}>
                    <Button
                        onClick={handleRechazar}
                        variant='contained'
                        color='error'
                    >
                        <BlockIcon sx={{ mt: -0.3, fontSize: 20 }} /> Rechazar
                    </Button>

                    <Button
                        onClick={() => setOpen2(null)}
                        variant='text'
                    >
                        <UndoIcon sx={{ mt: -0.3, fontSize: 20 }} /> Atrás
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};
